<template>
  <v-card class="mx-auto" flat max-width="344">
    <v-card-text>
      <v-img class="ma-4" :src="emptyState"></v-img>
      <div>
        <span class="title color-services">No {{ text }} Data To Show</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "EmptyState",
  props: ["text"],
  data() {
    return {
      emptyState: require("@/assets/emptyState.svg"),
    };
  },
};
</script>
